import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  chargebackAmount: Yup.string(),
  refundReason: Yup.string().required('Campo obrigatório.'),
});
